import { render, staticRenderFns } from "./AppraisalResidualRisk.vue?vue&type=template&id=15f8d764&"
import script from "./AppraisalResidualRisk.vue?vue&type=script&lang=ts&"
export * from "./AppraisalResidualRisk.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports